import { API_ENDPOINTS } from '../api/apiEndpoints';

export const EnergyOptimizationPayload = {
  chat_id: '',
  query: '',
  is_new_session: false,
  application_id: '',
  user_id: '',
}

export const StreamCallbacks = {
  onChunk: (partialContent) => {},
  onHeaderCreated: (header, conversationId) => {},
  onStreamComplete: (conversationId, pairId, images) => {},
}

export const streamEnergyOptimizationInsights = async (
  payload,
  callbacks
) => {
  // For streaming, we still need to use fetch as axios doesn't handle SSE streams well
  const accessToken = localStorage.getItem('access_token');
  
  const response = await fetch(API_ENDPOINTS.energyOptimization, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken && { 'Authorization': `Bearer ${accessToken}` }),
    },
    body: JSON.stringify(payload),
  });

  if (!response.body) {
    throw new Error('Streaming not supported');
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });

    const lines = buffer.split('\n');
    buffer = lines.pop() || ''; // carry over partial line

    for (const line of lines) {
      if (line.startsWith('data:')) {
        try {
          const jsonStr = line.replace(/^data:\s*/, '');
          const parsed = JSON.parse(jsonStr);

          if (parsed.text) {
            callbacks.onChunk(parsed.text);
          } else if (parsed.type === 'header_created' && parsed.header) {
            callbacks.onHeaderCreated?.(parsed.header, parsed.conversation_id);
          } else if (parsed.type === 'stream_complete') {
            callbacks.onStreamComplete?.(parsed.conversation_id, parsed.pair_id, parsed.images);
          }
        } catch (e) {
          console.error('Failed to parse SSE JSON line:', line, e);
        }
      }
    }
  }
};

